import React, { RefObject, useImperativeHandle, useRef } from 'react';

export type DefaultRefs = {
  dropdownArrowRef?: RefObject<HTMLDivElement | null>;
};

interface DefaultProps {
  disabled: boolean;
  defaultValue: string;
  value: string;
  openList: boolean;
}

export const DefaultView = React.forwardRef<DefaultRefs, DefaultProps>(
  (props, ref) => {
    const dropdownArrowRef = useRef<HTMLDivElement>(null);

    useImperativeHandle(ref, () => ({
      dropdownArrowRef,
    }));

    const { disabled, value, openList, defaultValue } = props;
    return (
      <>
        <div
          className={
            'text-bodyl font-sans font-normal ' +
            (disabled ? 'text-disabled-light' : 'text-text-light')
          }
        >
          {value === '' ? defaultValue : value}
        </div>

        <div
          ref={dropdownArrowRef}
          className={
            'relative z-20 duration-200 ease-linear ' +
            (openList ? '-scale-y-100' : 'scale-y-100')
          }
        >
          <svg height="7px" width="12px">
            <path
              width="12"
              height="10"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M 0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6 4.58579L10.2929 0.292893C10.6834 -0.0976311 11.3166 -0.0976311 11.7071 0.292893C12.0976 0.683417 12.0976 1.31658 11.7071 1.70711L6.70711 6.70711C6.31658 7.09763 5.68342 7.09763 5.29289 6.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893 Z"
              className={disabled ? 'fill-disabled-light' : 'fill-icon-default'}
            ></path>
          </svg>
        </div>
      </>
    );
  },
);

DefaultView.displayName = 'DefaultView';

